import { render, staticRenderFns } from "./DoctorDetailField.vue?vue&type=template&id=b0243b04&"
import script from "./DoctorDetailField.vue?vue&type=script&lang=js&"
export * from "./DoctorDetailField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports